<template>
  <div id="competency-modal" uk-modal>
    <div class="uk-modal-dialog uk-modal-body p-4" style="width: 600px;">
      <button class="uk-modal-close-default" type="button" uk-close></button>

      <div class="uk-modal-header uk-padding-remove-left">
        <h3 class="uk-modal-title">
          <i class="uil-plus"></i> {{ isEditMode ? $t('general.edit_competency') : $t('general.add_new_competency') }}
        </h3>
      </div>

      <div class="uk-modal-body p-0">
        <form @submit.prevent="handleSubmit">
          <div class="form-group row">
            <div class="col-md-12">
              <label class="col-form-label"> {{ $t('general.competency_name') }} <span class="required">*</span></label>
              <input v-model="form.name"
                     :class="{ 'is-invalid': errors.name }"
                     :placeholder="$t('general.competency_name')"
                     class="form-control"
                     required
                     type="text"
              />
              <div v-if="errors.name" class="invalid-feedback">
                {{ errors.name }}
              </div>
            </div>
          </div>

          <div class="form-group row">
            <div class="col-md-12">
              <label class="col-form-label"> {{ $t('general.description') }}</label>
              <textarea v-model="form.description"
                        :class="{ 'is-invalid': errors.description }"
                        :placeholder="$t('general.description')"
                        class="form-control"
                        rows="3"
              ></textarea>
              <div v-if="errors.description" class="invalid-feedback">
                {{ errors.description }}
              </div>
            </div>
          </div>

          <div class="form-group row">
            <div class="col-md-12">
              <div class="approval-checkbox-container">
                <label class="approval-checkbox-label">
                  <input v-model="form.requires_approval"
                         class="approval-checkbox"
                         type="checkbox"
                  />
                  <span class="checkmark"></span>
                  <span class="label-text"> {{ $t('general.requires_approval') }} </span>
                </label>
                <small class="form-text text-muted"> {{ $t('general.requires_approval_info') }}</small>
              </div>
            </div>
          </div>

          <div class="uk-flex uk-flex-right mt-4">
            <button :disabled="loading"
                    class="btn btn-outline-secondary mr-2"
                    type="button"
                    @click="closeModal"
            >
              {{ $t('general.cancel') }}
            </button>
            <button :disabled="loading"
                    class="btn btn-default"
                    type="submit"
            >
              <span v-if="loading" class="spinner-border spinner-border-sm mr-1"></span>
              {{ isEditMode ? $t('general.update') : $t('general.add') }}
            </button>
          </div>
        </form>
      </div>
    </div>
  </div>
</template>

<script>
import store from "@/core/services";
import competencies_module, {
  MODULE_NAME as COMPETENCIES_MODULE_NAME,
  BASE_URL,
  CREATE_ITEM,
  UPDATE_ITEM,
  LOADING,
  ERROR,
  SUCCESS,
  RESET_VALUES,
  UPDATE_ITEM_PUT
} from "@/core/services/store/competencies/competencies.module";

import { showSuccess, showError } from "@/utils/alertUtils";

const COMPETENCIES_MODULE = COMPETENCIES_MODULE_NAME;

export default {
  name: "CompetencyAddUpdateModal",

  data() {
    return {
      currentCompetency: null,
      form: {
        name: '',
        description: '',
        requires_approval: false
      },
      errors: {},
      loading: false
    };
  },
  computed: {
    isEditMode() {
      return !!this.currentCompetency;
    },
    errorMessage() {
      return this.$store.getters[COMPETENCIES_MODULE + '/' + ERROR];
    },
    successMessage() {
      return this.$store.getters[COMPETENCIES_MODULE + '/' + SUCCESS];
    }
  },
  beforeCreate() {
    function registerStoreModule(moduleName, storeModule) {
      if (!(store && store.state && store.state[moduleName])) {
        store.registerModule(moduleName, storeModule);
      }
    }

    registerStoreModule(COMPETENCIES_MODULE, competencies_module);
  },
  watch: {
    errorMessage(val) {
      if (val) {
        this.errors = this.parseErrors(val);
      }
    }
  },
  methods: {
    setCompetency(competency) {
      this.currentCompetency = competency;
      if (competency) {
        this.fillForm(competency);
      } else {
        this.resetForm();
      }
    },

    fillForm(competency) {
      this.form = {
        name: competency.name || '',
        description: competency.description || '',
        requires_approval: competency.requires_approval
      };
    },
    resetForm() {
      this.form = {
        name: '',
        description: '',
        requires_approval: false
      };
      this.errors = {};
    },
    parseErrors(errorMessage) {
      //  hata parsing
      const errors = {};
      if (typeof errorMessage === 'string') {
        if (errorMessage.includes('name')) {
          errors.name = this.$t('validation.competency_name_required')
        }
        if (errorMessage.includes('description')) {
          errors.description = this.$t('validation.description_required')
        }
      }
      return errors;
    },
    async handleSubmit() {
      this.loading = true;
      this.errors = {};

      try {
        if (this.isEditMode) {
          await this.$store.dispatch(COMPETENCIES_MODULE + '/' + UPDATE_ITEM_PUT, {
            url: `${BASE_URL}/${this.currentCompetency.id}`,
            contents: this.form
          });
        } else {
          await this.$store.dispatch(COMPETENCIES_MODULE + '/' + CREATE_ITEM, {
            url: BASE_URL,
            contents: this.form
          });
        }

        let successMessage = this.isEditMode ? this.$t('general.competency_updated_successfully') : this.$t('general.competency_created_successfully');
        showSuccess(successMessage, 3000);

        this.closeModal();
        this.$emit('success');

      } catch (error) {
        let errorMessage = this.isEditMode ? this.$t('general.error_occurred_while_updating_competency') : this.$t('general.error_occurred_while_adding_competency');
        showError(errorMessage, 3000);
      } finally {
        this.loading = false;
      }
    },
    openModal(competency = null) {
      // Competency'yi set et
      this.setCompetency(competency);

      // Modal'ı aç
      this.$nextTick(() => {
        UIkit.modal("#competency-modal").show();
      });
    },
    closeModal() {
      UIkit.modal("#competency-modal").hide();
      this.resetForm();
      this.$store.commit(COMPETENCIES_MODULE + '/' + RESET_VALUES);
      this.$emit('close');
    }
  }
};
</script>

<style scoped>
.required {
  color: red;
}

.is-invalid {
  border-color: #dc3545;
}

.invalid-feedback {
  display: block;
  width: 100%;
  margin-top: 0.25rem;
  font-size: 80%;
  color: #dc3545;
}

/* Custom Checkbox Design */
.approval-checkbox-container {
  margin-top: 10px;
}

.approval-checkbox-label {
  display: flex;
  align-items: center;
  position: relative;
  cursor: pointer;
  font-size: 16px;
  user-select: none;
  padding: 8px 0;
}

.approval-checkbox {
  position: absolute;
  opacity: 0;
  cursor: pointer;
  height: 0;
  width: 0;
}

.checkmark {
  height: 20px;
  width: 20px;
  background-color: #fff;
  border: 2px solid #ddd;
  border-radius: 4px;
  margin-right: 12px;
  position: relative;
  transition: all 0.2s ease;
}

.approval-checkbox-label:hover .checkmark {
  border-color: #007bff;
  background-color: #f8f9fa;
}

.approval-checkbox:checked ~ .checkmark {
  background-color: #007bff;
  border-color: #007bff;
}

.checkmark:after {
  content: "";
  position: absolute;
  display: none;
  left: 6px;
  top: 2px;
  width: 4px;
  height: 8px;
  border: solid white;
  border-width: 0 2px 2px 0;
  transform: rotate(45deg);
}

.approval-checkbox:checked ~ .checkmark:after {
  display: block;
}

.label-text {
  font-weight: 500;
  color: #333;
}

.form-text {
  margin-top: 5px;
  color: #6c757d;
  font-size: 14px;
}

/* Focus states for accessibility */
.approval-checkbox:focus ~ .checkmark {
  box-shadow: 0 0 0 3px rgba(0, 123, 255, 0.25);
}

/* Animation for checkbox */
.checkmark {
  transition: all 0.2s cubic-bezier(0.4, 0, 0.2, 1);
}

.approval-checkbox:checked ~ .checkmark {
  transform: scale(1.05);
}

/* Responsive design */
@media (max-width: 768px) {
  .approval-checkbox-label {
    font-size: 14px;
  }

  .checkmark {
    height: 18px;
    width: 18px;
  }

  .checkmark:after {
    left: 5px;
    top: 1px;
    width: 3px;
    height: 7px;
  }
}
</style>

